<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>退款-审核列表</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row
      v-if="resData"
      class="row"
      :gutter="20"
      type="flex"
      align="middle"
      justify="space-around"
    >
      <el-col
        v-for="item in resData.status_sum"
        :key="item.key"
        :span="24 / resData.status_sum.length"
        class="column"
      >
        <div
          class="status"
          :class="{ active: status === item.key }"
          @click="selectStatus(item.key)"
        >
          {{ item.label }}({{ item.num }})
        </div>
      </el-col>
    </el-row>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="输入搜索：">
                  <el-input
                    v-model="form.refund_id"
                    placeholder="退款单号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.supply_name"
                    placeholder="商家"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.market_name"
                    placeholder="市场"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>

                <el-form-item>
                  <el-input
                    v-model="form.work_id"
                    placeholder="工单id"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>

                <el-form-item>
                  <el-select
                    v-if="resData"
                    v-model="form.pg_id"
                    placeholder="选择代采组"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in selectedOptions.optionPg"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-if="resData"
                    v-model="form.source"
                    placeholder="退款类型"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in selectedOptions.optionReferer"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <!-- <el-form-item>
                                  <el-select v-model="form.dpc_id" placeholder="选择次品专员" v-if="resData">
                                    <el-option label="全部" value=""></el-option>
                                    <el-option :label="item.label" :value="item.key" v-for="item in resData.optionDpc" :key="item.key"></el-option>
                                  </el-select>
                                </el-form-item> -->
                <el-form-item v-if="resData">
                  <el-select v-model="form.status" placeholder="选择代采单状态">
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in selectedOptions.optionStatus"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-select
                    v-model="form.refund_status"
                    placeholder="选择退款途径"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in selectedOptions.optionWay"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.dgid"
                    filterable
                    placeholder="次品组"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in selectedOptions.dg_group"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.dpc_id"
                    filterable
                    placeholder="退换货负责人"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in selectedOptions.option_dgm"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item>
                  <el-select
                    v-model="form.referer"
                    filterable
                    placeholder="退款来源"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option label="一手" value="1"></el-option>
                    <el-option label="爆版" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>

            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="提交时间：">
                  <el-date-picker
                    v-model="form.create_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="审核时间：">
                  <el-date-picker
                    v-model="form.check_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="退款日期：">
                  <el-date-picker
                    v-model="form.transfer_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <el-row v-if="resData">
      <el-col v-if="resData.amount" :span="24" class="data-statics">
        数据汇总&nbsp;&nbsp;&nbsp;&nbsp;
        <span v-for="item in resData.amount" :key="item.sum_amount">
          {{
            item.sum_amount
          }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
        >
      </el-col>
    </el-row>
    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div style="width: 20%">数据列表：</div>
          <div style="text-align: right; width: 80%">
            <el-button type="success" size="mini" @click="output(true)">
              导出退款单商品</el-button
            >
            <el-button type="success" size="mini" @click="output(false)">
              导出</el-button
            >
          </div>
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            :row-class-name="tableRowClassName"
            @selection-change="handleSelectionChange"
          >
            <!-- <el-table-column type="selection" width="55">
                        </el-table-column> -->
            <!--<el-table-column prop="referer_type" label="退款类型" width="120" align="center">-->
            <!--</el-table-column>-->
            <el-table-column
              prop="refund_id"
              label="退款单号"
              width="120"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="market_name"
              label="市场"
              width="120"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="supply_name"
              label="商家"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pg_name"
              label="代采组"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="create_admin"
              label="申请人"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="referer_text"
              label="退款来源"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="refund_picture"
              label="退款单据"
              show-overflow-tooltip
              align="center"
            >
              <template #default="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    margin: auto;
                  "
                >
                  <img
                    v-for="(img, index) in scope.row.refund_picture"
                    :key="index"
                    style="width: 100%; height: 100%"
                    :src="img"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="transfer_time"
              label="退款日期"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="refund_num"
              label="退款件数"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="refund_amount"
              label="退款金额"
              show-overflow-tooltip
              align="center"
              width="250"
            ></el-table-column>
            <el-table-column
              prop="real_got_price"
              label="实收金额"
              show-overflow-tooltip
              align="center"
              width=""
            ></el-table-column>
            <el-table-column
              prop="wcg_refund_way"
              label="退款途径"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <!--<el-table-column prop="work_id" label="工单ID" show-overflow-tooltip align="center">-->
            <!--</el-table-column>-->
            <el-table-column
              prop="wcg_refund_status"
              label="状态"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="提交时间"
              width="100"
              sortable
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="check_admin"
              label="审核人"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="check_time"
              label="审核时间"
              width="100"
              sortable
              align="center"
            >
            </el-table-column>

            <el-table-column
              prop="dg_group_name"
              label="次品组"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="dgm_name"
              label="退换货负责人"
              align="center"
            ></el-table-column>
            <el-table-column label="操作" show-overflow-tooltip align="center">
              <template #default="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="handleClick(scope.row)"
                  >查看详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-col v-if="resData" style="text-align: right; padding: 25px">
            <el-pagination
              :current-page.sync="curPage"
              background
              layout="total, prev, pager, next, jumper "
              :total="Number(resData.count)"
              :page-size="10"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </el-col>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import dayjs from "dayjs";
import apiBaseURL from "@/utils/baseUrl.js";
import { getOptionsForCheckRefund } from "@/openapi/erp/refund.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      dayjs,
      resData: null,
      form: { create_time: this.defaultDate() },
      loading: false,
      url: "/erp/refund/checkRefund",
      status: "",
      curPage: 1,
      tableLoading: false,
      filterFold: false,
      multipleSelection: [],
      selectedOptions: {}, // 筛选项列表
    };
  },
  computed: {
    filteredForm() {
      // for (const key in this.form) {
      //   if (
      //     this.form[key] === undefined ||
      //     this.form[key] === "" ||
      //     this.form[key] === null
      //   ) {
      //     delete this.form[key];
      //   }
      // }
      const { form } = this;
      Object.keys(form).forEach((key) => {
        if (form[key] === undefined || form[key] === "" || form[key] === null) {
          delete form[key];
        }
      });
      return form;
    },
  },
  methods: {
    output(isRefundGoods) {
      this.form.is_excel = 1;
      if (isRefundGoods) {
        this.form.is_refund_goods = 1;
      } // 导出退款单商品
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.form.is_excel = 0;
        if (isRefundGoods) {
          this.form.is_refund_goods = 0;
        } // 导出退款单商品
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          window.open(apiBaseURL + res.data.data.file);
        }
      });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
      // 请求筛选项
      getOptionsForCheckRefund().then((res) => {
        this.selectedOptions = res;
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    tableRowClassName({ row }) {
      if (row.has_common) {
        // notice-row
        return "warning-row";
      }
      return "";
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
        .map((v) => {
          return v.refund_id;
        })
        .join(",");
    },
    onSubmit() {},
    handleCurrentChange(val) {
      this.form.page = val;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleClick(row) {
      this.$router.push(`/home/purchaserefunddetail/${row.refund_id}`);
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          this.status = this.filteredForm.status;
          this.curPage = 1;
        }
      });
    },
    selectStatus(key) {
      this.loading = true;
      this.status = key;
      this.form.status = key;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    defaultDate() {
      return this.$excalibur.getDateTimeOnHours(-30);
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1 px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 80px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/PurchaseRefundList.vue